import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { EmvioCheckbox } from '@nexio/emvio-form-components';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import { connect } from 'react-redux';
import { editMerchant } from '../merchantManagementActions';
import { getEditMerchantError } from '../merchantManagementEntity';

export class MerchantEnabledCheckbox extends Component {
    static propTypes = {
        checked: PropTypes.bool,
        merchantId: PropTypes.string,
        onEditMerchant: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            checked: props.checked
        };
    }

    componentDidUpdate(prevProps) {
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'checked')) {
            this.setState({ checked: this.props.checked });
        }
        // if there is an error we use the checked prop from the previous merchant configuration
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'editMerchantError')) {
            this.setState({ checked: prevProps.checked });
        }
    }

    handleChange = () => {
        this.setState((prevState) => {
            return { checked: !prevState.checked };
        }, () => {
            this.props.onEditMerchant({
                merchantId: this.props.merchantId,
                enabled: this.state.checked
            });
        });
    };

    render() {
        return (
            <div className="merchant-enabled-checkbox">
                <EmvioCheckbox checked={this.state.checked} onChange={this.handleChange}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        editMerchantError: getEditMerchantError(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onEditMerchant: (merchant) => dispatch(editMerchant(merchant))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MerchantEnabledCheckbox);
